export enum STORAGE_KEY {
  LOCALE = 'LOCALE',
  THEME = 'THEME',
  FROM_CHAIN_ID = 'FROM_CHAIN_ID',
  FROM_CHAIN_TYPE = 'FROM_CHAIN_TYPE'
}
